/** Segment de chemin sans query/hash (pour lire l’extension sur les URLs storage). */
export function pieceUrlPathOnly(url: string): string {
  return url.split(/[?#]/)[0];
}

/** Aperçu adapté : photos mobile (JPG/PNG/WebP/HEIC…), pas via iframe « PDF ». */
export function pieceUrlIsLikelyImage(url: string): boolean {
  return /\.(jpe?g|png|webp|gif|heic|bmp|avif)$/i.test(pieceUrlPathOnly(url));
}

export function pieceUrlIsLikelyPdf(url: string): boolean {
  return /\.pdf$/i.test(pieceUrlPathOnly(url));
}
